import type {
	OptimizationGroupModel,
	PricingCampaignModel,
} from '@/shared/generated'

import React from 'react'
import { prop } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import { useOptimizationGroupsQuery } from '@/entities/optimization-group'
import { usePricingCampaignsQuery } from '@/entities/pricing-campaign'

import { useOptimizationGroupId } from '@/shared/hooks/useOptimzationGroupId'

type CheckoutProps = {
	formData: {
		campaigns: string[]
		groups: string[]
	}
}
function selectItemsIn<T = unknown>(selcted: string[]) {
	return (data: T[]): string[] =>
		data.filter(({ id }: any) => selcted.includes(id)).map(prop('name'))
}

function Checkout({ formData }: CheckoutProps) {
	const { t } = useTranslation()

	const selectedCampaigns = formData.campaigns
	const selectedGroups = formData.groups
	const optimizationGroupId = useOptimizationGroupId()
	const pricingCampaignsQuery = usePricingCampaignsQuery<string[]>(
		{
			optimization_group_id: optimizationGroupId,
		},
		{
			select: selectItemsIn<PricingCampaignModel>(selectedCampaigns),
		}
	)
	const optimizationGroupsQury = useOptimizationGroupsQuery<string[]>({
		select: selectItemsIn<OptimizationGroupModel>(selectedGroups),
	})

	return (
		<div className='grid grid-cols-2 gap-4'>
			<div>
				<h5>{t('pc.copy.want_to_copy')}</h5>
				<ul className='ml-2 h-64 overflow-y-scroll'>
					{pricingCampaignsQuery.data?.map((name) => (
						<li key={name}>{name || 'None'}</li>
					))}
				</ul>
			</div>
			<div>
				<h5>{t('pc.copy.to_following_ogs')}:</h5>
				<ul className='ml-2 h-64 overflow-y-scroll'>
					{optimizationGroupsQury.data?.map((name) => (
						<li key={name}>{name || 'None'}</li>
					))}
				</ul>
			</div>
		</div>
	)
}

export default Checkout
